isExperimentVariationActive